// COMPONENT
import TelegramIcon from "@/components/Icons/messengerComponent/TelegramIcon";
import ViberIcon from "@/components/Icons/messengerComponent/ViberIcon";
// SVG
import viberSvg from "@/assets/icons/messengers/viber_btn.svg";
import telegramSvg from "@/assets/icons/messengers/telegram_btn.svg";
import whatsappSvg from "@/assets/icons/messengers/whatsapp_btn.svg";
import tiktokSvg from "@/assets/icons/messengers/tiktok_btn.svg";
// PNG "logo in phone"
import viberPng from "@/assets/images/activation/viber.png";
import telegramPng from "@/assets/images/activation/telegram.png";
import whatsappPng from "@/assets/images/activation/whatsapp.png";

// Держим TikTok отдельно от списка мессенджеров: он нужен только в шапке,
// а `default` перебирается в тарифах/калькуляторе/активации.
export const TIKTOK = {
    title: "Tiktok",
    value: "tiktok",
    icon: "fab fa-tiktok",
    color: "var(--tiktok-color)",
    svg: tiktokSvg,
    ribbon: "Free Beta",
    connectAccount: true,
};

export default {
    viber: {
        title: "Viber",
        value: "viber",
        icon: "fab fa-viber",
        connectNumberIcon: "icon-viber",
        color: "var(--viber-color)",
        svg: viberSvg,
        component: ViberIcon,
        logoInPhone: viberPng,
    },
    telegram: {
        title: "Telegram",
        value: "telegram",
        icon: "fab fa-telegram",
        connectNumberIcon: "icon-telegram",
        svg: telegramSvg,
        color: "var(--telegram-color)",
        component: TelegramIcon,
        logoInPhone: telegramPng,
    },
    whatsapp: {
        title: "Whatsapp",
        value: "whatsapp",
        icon: "fab fa-whatsapp",
        color: "var(--whatsapp-color)",
        svg: whatsappSvg,
        logoInPhone: whatsappPng,
    },
};
